import { Pencil, Share2, Sparkles, Trash2 } from 'lucide-react-native';
import { memo } from 'react';
import { BiButton } from '../../components/ui/BiButton';

/** The dataset page's header actions; managing ones for `manage` only. */
export const DatasetActions = memo(
  ({
    compact,
    canManage,
    showAnalyze,
    deleting,
    onAnalyze,
    onEdit,
    onShare,
    onDelete,
  }: {
    compact: boolean;
    canManage: boolean;
    /** Hidden while the chat sits open beside the page. */
    showAnalyze: boolean;
    deleting: boolean;
    onAnalyze: () => void;
    onEdit: () => void;
    onShare: () => void;
    onDelete: () => void;
  }) => (
    <>
      {showAnalyze ? (
        <BiButton
          icon={Sparkles}
          title="用 AI 分析"
          tone="primary"
          onPress={onAnalyze}
        />
      ) : null}
      {canManage ? (
        <>
          <BiButton
            icon={Pencil}
            title={compact ? undefined : '编辑'}
            accessibilityLabel="编辑名称和说明"
            onPress={onEdit}
          />
          <BiButton
            icon={Share2}
            title={compact ? undefined : '共享'}
            accessibilityLabel="共享"
            onPress={onShare}
          />
          <BiButton
            icon={Trash2}
            title={compact ? undefined : '删除'}
            accessibilityLabel="删除"
            loading={deleting}
            onPress={onDelete}
          />
        </>
      ) : null}
    </>
  ),
);
